import { Currency } from "components/CustomCurrency/currency";
import { Unit } from "components/CustomUnits/units";
import SalesActionMenu from "./actionsMenu";

function getTableData(products, setEditing, setElementToEdit, setDeleting) {
  // param: products list of: [
  //     {
  //       "createdDate": 1618932310934,
  //       "modifiedDate": 1618932310934,
  //       "createdBy": "direccionmedica@cclabs.com.ec",
  //       "modifiedBy": "direccionmedica@cclabs.com.ec",
  //       "id": 85772,
  //       "product": {
  //           "createdDate": 1527881785645,
  //           "modifiedDate": 1686844186993,
  //           "modifiedBy": "emevet@aensaecuador.org",
  //           "id": 8970,
  //           "code": "C001",
  //           "name": "6 PIRYN",
  //           "presentation": "ENVASE ",
  //           "manufacturer": "LABORATORIOS PHARMAVITAL",
  //           "activeMolecularCompound": "ACETAMINOFÉN",
  //           "unitContent": "1 KG",
  //           "description": "PREVIENE EL GOLPE DE CALOR EN AVES",
  //           "administration": "VÍA ORAL",
  //           "categoryId": 416,
  //           "sectorId": 12,
  //           "subSectorId": 25,
  //           "groupId": 86,
  //           "formId": 220,
  //           "companyId": 3912,
  //           "active": true
  //       },
  //       "productId": 8970,
  //       "year": 2021,
  //       "quarterId": 182,
  //       "quantity": 245,
  //       "pvp": 16.80
  //   }
  //  ]

  var rows = [];
  products.forEach((elem, index) => {
    var _temp = {
      Nro: index + 1,
      Producto: elem.product.name,
      Codigo: elem.product.code,
      Presentacion: elem.product.presentation,
      Unidad: elem.product.unitContent,
      neto: <Currency value={elem.pvp} />,
      Cantidad: <Unit value={elem.quantity} />,
      Acciones: (
        <SalesActionMenu
          setEditing={setEditing}
          element={elem}
          setElementToEdit={setElementToEdit}
          setDeleting={setDeleting}
        />
      ),
    };
    rows.push(_temp);
  });

  // return values in a format that charts components understand
  return {
    columns: [
      { Header: "Nro", accessor: "Nro", width: "5%" },
      { Header: "Producto", accessor: "Producto" },
      { Header: "Codigo", accessor: "Codigo" },
      { Header: "Presentacion", accessor: "Presentacion" },
      { Header: "Unidad", accessor: "Unidad" },
      { Header: "PVP", accessor: "neto" },
      { Header: "Cantidad", accessor: "Cantidad" },
      { Header: "Acciones", accessor: "Acciones", width: "10%" },
    ],
    rows: rows,
  };
}

export default getTableData;
